import React from "react";
import Icon from "@/components/icons";
import useTranslations from "@/i18n/useTranslations";

export interface BenefitListProps {
  benefits?: string[];
  title?: string;
}

const BenefitList = ({ benefits = [], title }: BenefitListProps) => {
  const t = useTranslations("Common");
  const resolvedTitle = title ?? t("whyTakeThisProgram");
  return (
    <div className="bg-[#00262B] rounded-xl p-6 text-white w-full flex flex-col">
      <h3 className="text-xl font-bold text-center text-white mt-0 gap-6 mb-6">
        {resolvedTitle}
      </h3>

      <ul className="flex flex-col gap-4">
        {benefits.map((benefit, index) => (
          <li key={index} className="flex items-start gap-3">
            <div className="flex items-center justify-center mt-1">
              <Icon
                type="circle-check-outline"
                svgProps={{ width: "20", height: "20" }}
              />
            </div>
            <span className="text-white text-base">{benefit}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BenefitList;
